/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _|
 | |_| | | | | |_) || |  / / | | |  \| | | | | || |
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|

=========================================================
* Horizon UI - v1.0.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, Flex } from "@chakra-ui/react";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks";
import avatar from "assets/img/avatars/avatar.png";
// Assets
import banner from "assets/img/profile/emm-banner.jpg";
import axios from "axios";
import YourCard from "components/card/YourCard";
import React, { useEffect, useState } from "react";
// Custom components
import Banner from "views/admin/profile/components/Banner";



export default function Overview() {
  const { address } = useGetAccountInfo();
  const [herotag, setHerotag] = useState();

  useEffect(async () => {
    const response = await axios.get(`https://api.elrond.com/accounts/${address}`)
      .catch(e => console.error(e));
    const data = response.data.username;
    setHerotag(data?.split('.')[0]);
  }, [])

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Flex
        gap={{ base: "20px", xl: "20px" }}>
        <Banner
          banner={banner}
          avatar={avatar}
          herotag={herotag}
          address={address}
        />
      </Flex>
      <YourCard mt={'16px'}></YourCard>
    </Box>
  );
}
